import React from 'react'
import styled from 'styled-components'

const StyledP = styled.p`
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  font-size: 10pt;
`

const ContextPaneDescription = props => {
  return <StyledP>{props.elementDescription}</StyledP>
}

export default ContextPaneDescription
